module.exports = __webpack_public_path__ + "static/media/energie.3cfa479e.jpg";